import { render, staticRenderFns } from "./SfButton.vue?vue&type=template&id=9accbd48&functional=true&"
import script from "./SfButton.vue?vue&type=script&lang=js&"
export * from "./SfButton.vue?vue&type=script&lang=js&"
import style0 from "./SfButton.vue?vue&type=style&index=0&id=9accbd48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports